import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AssetsManagementService } from '../../services/assets-management.service';
import { AssetsManagementModel, SubTypeModel, MainAssetModel, TransferUserModel } from '../assets-management.model';
import { MasterDataService } from '../../services/master-data.service';
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-software-assets',
  templateUrl: './software-assets.component.html',
  styleUrls: ['./software-assets.component.css']
})
export class SoftwareAssetsComponent implements OnInit {
  assetsManagementModel: AssetsManagementModel;
  mainAssetModel: MainAssetModel;
  transferUserModel: TransferUserModel;
  softwareAssetsTypeList;
  softwareType: SubTypeModel;
  softwareAssetsList;
  hideSaveButton = false;
  selectedEmployeeStatus;
  softwareStatus;
  userRole;
  showAddSoftwareButton;
  serialTagList = [];
  branchList;
  selectBranch;
  currentDate;
  formatCurrentDate;
  previousMonthCurrentDate;

  constructor(private modalService: NgbModal,
    private assetsManagementService: AssetsManagementService,
    private masterDataService: MasterDataService,
    private commonMessageService:CommonMessageService) {
    const current = new Date();
    this.currentDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  // search = (text$: Observable<string>) => {
  //   return text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     map(term => term.length < 1 ? []
  //       : this.getSerialTagNumberList(term)),
  //     debounceTime(2000),
  //     map(term => this.serialTagList.filter(serviceTag => new RegExp(term, 'mi').test(serviceTag.name)).slice(0, 10))
  //   )
  // }

  // // resultFormatter(value: any) {
  // //   return value.name;
  // // }

  // inputFormatter(value: any) {
  //   return value.serviceTagNumber;
  // }

  // getSerialTagNumberList(text: string): any {
  //   if (text != "") {
  //     this.assetsManagementService.serviceTagNumberList('Software').subscribe((resp: any) => {
  //       this.serialTagList = resp;
  //       console.log('typeahead serialtag list', this.serialTagList);
  //     });
  //   }
  // }

  ngOnInit(): void {
    var currentDate1 = new Date(this.currentDate.year + '-' + this.currentDate.month + '-' + this.currentDate.day);
    this.formatCurrentDate = moment(currentDate1).format("YYYY-MM-DD");
    var newDate = new Date(this.formatCurrentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    var changeNewDate = newDate.toLocaleDateString();
    var againChangeNewDate = new Date(changeNewDate);
    this.previousMonthCurrentDate = {
      year: againChangeNewDate.getFullYear(),
      month: againChangeNewDate.getMonth() + 1,
      day: againChangeNewDate.getDate(),
    };

    this.selectedTransferServiceTag = null;
    this.showtransferFromValue = "";
    this.transferTo = "";
    this.showProductKey = "";
    this.userRole = localStorage.getItem('userRole');
    if (this.userRole == 'Account Executive' || this.userRole == 'HR Assistant' ||
      this.userRole == 'HR Executive' || this.userRole == 'HR Manager' || this.userRole == 'Partner') {
      this.showAddSoftwareButton = true;
    } else {
      this.showAddSoftwareButton = false;
    }
    this.selectedEmployeeStatus = 'all';
    this.assetsManagementModel = new AssetsManagementModel();
    this.mainAssetModel = new MainAssetModel();
    this.transferUserModel = new TransferUserModel();
    this.getBranchList();
    this.getTypeSoftwareList();
    // this.getAllSoftwareAssetsList();
    this.getHardwareServiceTagList();
    this.getServiceTagNumberList();
  }

  openTransferModal(transferModalContent) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(transferModalContent, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openModal(modalContent) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(modalContent, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  closeModal() {
    this.getAllSoftwareAssetsList();
    this.getServiceTagNumberList();
    this.hideSaveButton = false;
    this.showtransferFromValue = "";
    this.transferTo = "";
    this.showProductKey = "";
    this.assetsManagementModel = new AssetsManagementModel();
    this.modalService.dismissAll();
  }

  viewSoftwareAssetDetails;
  viewSoftwareAssets(softwareDetails, modalContent) {
    console.log('view siftware details', softwareDetails);
    this.viewSoftwareAssetDetails = softwareDetails;
    this.openTransferModal(modalContent);
  }

  myFiles = [];
  docType = [];
  fileChange(event, documentType) {
    console.log('document type', event);
    for (var i = 0; i < event.target.files.length; i++) {
      this.myFiles.push(event.target.files[i]);
      this.docType.push(documentType);
    }
    console.log('this.myFiles', this.myFiles);
    console.log('this.docType', this.docType);
  }

  getBranchList() {
    this.masterDataService.getBranch().subscribe((res) => {
      console.log('branchlist', res);
      this.branchList = res;
      var branchIndex = -1;
      this.branchList.forEach((element, key) => {
        if (element.name == 'Pune') {
          branchIndex = key;
        }
      });
      this.selectBranch = this.branchList[branchIndex];
      this.getAllSoftwareAssetsList();
    });
  }

  onBranchChange() {
    this.getAllSoftwareAssetsList();
  }

  getTypeSoftwareList() {
    this.assetsManagementService.getTypeSoftwareAssets().subscribe((resp: any) => {
      this.softwareAssetsTypeList = resp;
      console.log('software list', this.softwareAssetsTypeList);
    });
  }

  onAddSoftwareAsset() {
    console.log('software this.assetsManagementModel value', this.assetsManagementModel);
    this.assetsManagementService.setAssetsManagementModel(this.assetsManagementModel);
    if (
      // this.assetsManagementModel.serviceTagNumber == undefined || this.assetsManagementModel.serviceTagNumber == "" ||
      this.assetsManagementModel.dateOfPurchase == undefined || this.assetsManagementModel.dateOfPurchase == null ||
      // this.assetsManagementModel.expiryDate == undefined || this.assetsManagementModel.expiryDate == undefined ||
      this.assetsManagementModel.assetName == undefined || this.assetsManagementModel.assetName == "" ||
      this.assetsManagementModel.subType == null || this.assetsManagementModel.subType == undefined ||
      this.assetsManagementModel.branch == undefined) {
      this.commonMessageService.swalAlertWithoutIcon('','Please select mandatory fields');
      return;
    }
    this.assetsManagementService.addSoftwareAssetsDetails(this.myFiles, this.docType, this.hideSaveButton);
    setTimeout(() => {
      this.closeModal();
    }, 3000);
  }

  editSoftwareAsset(data, modalContent) {
    console.log("data", data, 'branch', this.selectBranch)

    this.assetsManagementModel = new AssetsManagementModel();
    console.log("assetsManagementModel", this.assetsManagementModel)
    this.assetsManagementService.setAssetsManagementModel(data);
    this.assetsManagementModel = this.assetsManagementService.getAssetsManagementModel();
    console.log('assetsManagementModel.dateOfSale', this.assetsManagementModel.dateOfSale);

    if(this.assetsManagementModel.expiryDate!=null){
    var expiryDate = new Date(this.assetsManagementModel.expiryDate);
    var formatExpiryDate = { year: expiryDate.getFullYear(), month: expiryDate.getMonth() + 1, day: expiryDate.getDate() };
    this.assetsManagementModel.expiryDate = formatExpiryDate;
    }

    if(this.assetsManagementModel.dateOfPurchase!=null){
    var purchaseDate = new Date(this.assetsManagementModel.dateOfPurchase);
    var formatPurchaseDate = { year: purchaseDate.getFullYear(), month: purchaseDate.getMonth() + 1, day: purchaseDate.getDate() };
    this.assetsManagementModel.dateOfPurchase = formatPurchaseDate;
    }

    if(this.assetsManagementModel.pgbPurchaseAccountingVoucherDate!=null){
    var dateOfpgbPurchaseAccountingVoucher = new Date(this.assetsManagementModel.pgbPurchaseAccountingVoucherDate);
    var formatDateOfpgbPurchaseAccountingVoucher = { year: dateOfpgbPurchaseAccountingVoucher.getFullYear(), month: dateOfpgbPurchaseAccountingVoucher.getMonth() + 1, day: dateOfpgbPurchaseAccountingVoucher.getDate() };
    this.assetsManagementModel.pgbPurchaseAccountingVoucherDate = formatDateOfpgbPurchaseAccountingVoucher;
    }

    if(this.assetsManagementModel.vendorInvoiceDate!=null){
    var dateOfVendorInvoice = new Date(this.assetsManagementModel.vendorInvoiceDate);
    var formatDateOfVendorInvoice = { year: dateOfVendorInvoice.getFullYear(), month: dateOfVendorInvoice.getMonth() + 1, day: dateOfVendorInvoice.getDate() };
    this.assetsManagementModel.vendorInvoiceDate = formatDateOfVendorInvoice;
    }

    const branchIndex = this.branchList.findIndex((item) => item.id == data.branch.id);
    this.assetsManagementModel.branch = this.branchList[branchIndex];
    console.log('branch name', this.selectBranch);

    if (this.assetsManagementModel.dateOfSale != null) {
      console.log("in assetsManagementModel")
      var saleDate = new Date(this.assetsManagementModel.dateOfSale);
      var formatSaleDate = { year: saleDate.getFullYear(), month: saleDate.getMonth() + 1, day: saleDate.getDate() };
      this.assetsManagementModel.dateOfSale = formatSaleDate;
    }



    const softwareTypeIndex = this.softwareAssetsTypeList.subType.findIndex((item) => item.id == data.subType.id);
    this.assetsManagementModel.subType = this.softwareAssetsTypeList.subType[softwareTypeIndex];


    this.hideSaveButton = true;
    this.openModal(modalContent);
  }

  // blockSoftwareData(data) {
  //   console.log('data', data);
  //   console.log('hideSAvebutton', this.hideSaveButton);
  //   data.block = !data.block;
  //   // if (data.block) {
  //   //   this.softwareStatus = 'Blocked';
  //   // } else {
  //   //   this.softwareStatus = 'InStock';
  //   // }
  //   console.log('this.assetsManagementModel.block', data);
  //   this.assetsManagementService.setAssetsManagementModel(data);
  //   this.assetsManagementService.blockSoftwareAssetsDetails(this.myFiles);
  //   setTimeout(() => {
  //     this.getAllSoftwareAssetsList();
  //   }, 2000);
  // }

  getServiceTagNumberList() {
    this.assetsManagementService.serviceTagNumberList('Software').subscribe((resp: any) => {
      this.serialTagList = resp;
      console.log('typeahead serialtag list', this.serialTagList);
    });
  }

  getAllSoftwareAssetsList() {
    console.log('software status', this.selectedEmployeeStatus);
    this.assetsManagementService.getSoftwareAssetsList(this.selectBranch.id, this.selectedEmployeeStatus).subscribe((resp: any) => {
      console.log('softwarelist', this.softwareAssetsList);
      // resp.map((res: any) => {
      //   console.log('inside getlist', res.block);
      //   if (res.block) {
      //     console.log('res.block', res.block);
      //     this.softwareStatus = 'Blocked';
      //   } else {
      //     this.softwareStatus = 'Instock'
      //   }
      //   // else if (res.release) {
      //   //   this.softwareStatus = 'Released';
      //   // } else if (res.retired) {
      //   //   this.softwareStatus = 'Instock';
      //   // }
      // })

      this.softwareAssetsList = resp;
      console.log('softwarelist', this.softwareAssetsList);
    });
  }

  disableEditButton: boolean;
  getSoftwareStatus(data) {
    var status;
    if (data.software.block == true && data.software.release == false && data.software.retired == false) {
      status = 'Blocked';
    } else if (data.software.block == false && data.software.release == true && data.software.retired == false) {
      status = 'Released';
    } else if (data.software.block == false && data.software.release == false && data.software.retired == true) {
      status = 'Retired';
    } else if (data.hardware != null) {
      status = 'Assigned';
    } else {
      status = 'Instock'
    }
    return status;
  }


  setFromUserValue() {
    console.log('selectedTransferServiceTag', this.selectedTransferServiceTag);
    this.showProductKey = this.selectedTransferServiceTag.productKey;
    if (this.selectedTransferServiceTag.asset != null) {
      this.showtransferFromValue = this.selectedTransferServiceTag.asset.serviceTagNumber;
    } else {
      this.showtransferFromValue = "InStock";
    }
  }

  // setFromUserValue(selectedTransferItem) {
  //   console.log('onitem select value', selectedTransferItem.item);

  //   if (selectedTransferItem.item.asset != null) {
  //     this.showtransferFromValue = selectedTransferItem.item.asset.serviceTagNumber;
  //     this.transferFrom = selectedTransferItem.item.asset;
  //   } else {
  //     this.showtransferFromValue = 'In Stock';
  //   }
  //   this.selectedTransferServiceTag = selectedTransferItem.item;
  // }

  selectedTransferServiceTag;
  transferFrom;
  showtransferFromValue;
  transferTo;
  transferDate;
  showProductKey;
  excuteTransferDetails() {
    var isRelease = false;
    var transferFromId;
    if (this.transferFrom == null) {
      transferFromId = 0;
    } else {
      transferFromId = this.transferFrom.id;
    }
    if (this.transferTo == "" ||
      // this.transferFrom == undefined ||
      this.selectedTransferServiceTag == null ||
      this.transferDate == undefined) {
      this.commonMessageService.swalAlertWithoutIcon('','Please select all fields');
      return;
    }
    var selectedRequestDate1 = new Date(this.transferDate.year + '-' + this.transferDate.month + '-' + this.transferDate.day);
    var selectedRequestDate2 = moment(selectedRequestDate1).format("YYYY-MM-DD");

    console.log('execute reponse', this.transferDate, this.selectedTransferServiceTag, this.transferFrom, this.transferTo);
    this.assetsManagementService.executeSoftwareTransfer(this.selectedTransferServiceTag.id, transferFromId, this.transferTo.id, isRelease, selectedRequestDate2);
    setTimeout(() => {
      this.closeModal();
    }, 3000);
  }

  selectServiceTag() {
    console.log('service tag intfo', this.selectedTransferServiceTag);
  }

  hardwareSerialTagList;
  getHardwareServiceTagList() {
    this.assetsManagementService.gateHardwareServiceTagNumberListForSoftware().subscribe((resp: any) => {
      this.hardwareSerialTagList = resp;
      console.log('hardware service tag numberlist', this.hardwareSerialTagList);
    })
  }

  // checkSerialTagNumber() {
  //   console.log('serial tag value', this.serialTagList.length);
  //   if (this.serialTagList.length == 0) {
  //     console.log('inside if')
  //     this.commonMessageService.swalAlertWithoutIcon('','Can not select Blocked, Retired & Assigned assets');
  //     this.selectedTransferServiceTag = null;
  //     this.showtransferFromValue = undefined;
  //   }
  // }
}
